const GRID_COLUMNS = import.meta.env.VITE_REACT_APP_GRID_COLUMNS ?? 12;

export const uiConfig = {
  grid: {
    columns: GRID_COLUMNS,
    columnsClass: `grid-cols-${GRID_COLUMNS}`,
    maxColumnsSpanClass: `col-span-${GRID_COLUMNS}`,
  },
};
